export type MutuallyExclude<T, E extends keyof T> =
  | {
      [K in E]: { [P in K]: T[P] } & Omit<T, E> & {
          [P in Exclude<E, K>]?: never;
        } extends infer O
        ? { [P in keyof O]: O[P] }
        : never;
    }[E]
  | ({ [K in E]?: never } & Omit<T, E>);

export function getExclusiveElement<T extends {}>(obj: T, choices: (keyof T)[]) {
  const isIncluded = (key: keyof T) => choices.includes(key);

  for (const key in obj) {
    if (isIncluded(key)) return key;
  }
}